var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from "react";
import { Controller } from "react-hook-form";
import { useIntl } from "react-intl";
import { RecekSelect } from "./RecekSelect";
export var AlternativeNameTypeSelect = function (_a) {
    var control = _a.control, name = _a.name, highlight = _a.highlight, autoComplete = _a.autoComplete, _b = _a.labelId, labelId = _b === void 0 ? "ui-br-publishers.publishers.alternativeNames.select.label.type" : _b;
    var formatMessage = useIntl().formatMessage;
    var dataOptions = useMemo(function () { return [
        {
            value: "",
            label: formatMessage({
                id: "ui-br-publishers.publishers.alternativeNames.select.label.notSpecified",
            }),
        },
        {
            value: "PREVIOUS",
            label: formatMessage({
                id: "ui-br-publishers.publishers.alternativeNames.type.previous",
            }),
        },
        {
            value: "IMPRINT",
            label: formatMessage({
                id: "ui-br-publishers.publishers.alternativeNames.type.imprint",
            }),
        },
        {
            value: "ABBREVIATION",
            label: formatMessage({
                id: "ui-br-publishers.publishers.alternativeNames.type.abbreviation",
            }),
        },
        {
            value: "ORGANIZATION_UNIT",
            label: formatMessage({
                id: "ui-br-publishers.publishers.alternativeNames.type.organizationUnit",
            }),
        },
        {
            value: "FOREIGN_LANGUAGE",
            label: formatMessage({
                id: "ui-br-publishers.publishers.alternativeNames.type.foreignLanguage",
            }),
        },
    ]; }, [formatMessage]);
    return (React.createElement(Controller, { control: control, name: name, render: function (_a) {
            var _b;
            var field = _a.field;
            return (React.createElement(RecekSelect, __assign({}, field, { value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                    return field.onChange(e.target.value || undefined);
                }, autoComplete: autoComplete, highlight: typeof highlight === "function" ? highlight(field.value) : highlight, labelId: labelId, dataOptions: dataOptions })));
        } }));
};
